/** Default Z-Index value for the wrapper component. */
export const DEFAULT_Z_INDEX = 1099;